import {ComponentProps} from 'react'
import StartSearchButton from "./StartSearchButton";

export const docProps : ComponentProps<typeof StartSearchButton> = {}

export default StartSearchButton;
